module.exports = __webpack_public_path__ + "img/bg10.fa099de3.gif";